var map = {
	"./bulb-active.svg": "0469",
	"./bulb.svg": "8d4c",
	"./cat.jpg": "6809",
	"./decor.svg": "e20c",
	"./dreamer.gif": "11ea",
	"./dreamer.jpg": "9bfb",
	"./fb.svg": "4d80",
	"./garland.svg": "655e",
	"./garland_1.svg": "137c",
	"./garland_2.svg": "67e9",
	"./garland_3.svg": "c74f",
	"./garland_4.svg": "d281",
	"./garland_5.svg": "ff3f",
	"./gift.svg": "a44a",
	"./hat.svg": "5320",
	"./inventor.gif": "4f18",
	"./inventor.jpg": "9703",
	"./logo.svg": "ff44",
	"./mastermind.gif": "1a35",
	"./mastermind.jpg": "4110",
	"./preview.png": "8834",
	"./researcher.gif": "7433",
	"./researcher.jpg": "d8ff",
	"./snowflake.svg": "78bd",
	"./traveler.gif": "f659",
	"./traveler.jpg": "e53e",
	"./tree.svg": "edf6",
	"./vk.svg": "2a54",
	"./wizard.gif": "706d",
	"./wizard.jpg": "0c7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b772";